import styled from '../../../utils/styling/styled';

import Section from '../../Heading/Section';
import styleUtils from '../../../utils/styling/styleUtils';

export const StaticPageSection = styled(Section)`
  /* ${styleUtils.margin.vertical.bottomHalf}; */
`;
